import { select } from "redux-saga/effects";
import { getCurrentLanguageFromUrl } from "./urlLanguageUtils";

export function* getCurrentLanguage(): Generator<any, "fa" | "en", any> {
  const urlLanguage = getCurrentLanguageFromUrl();
  if (urlLanguage && (urlLanguage === "fa" || urlLanguage === "en")) {
    return urlLanguage;
  }

  const reduxLanguage: "fa" | "en" = yield select((state: any) => state.language.locale);
  return reduxLanguage || "fa";
}

export function* getCurrentTheme(): Generator<any, string, any> {
  const reduxTheme: string = yield select((state: any) => state.theme.name);
  return reduxTheme || "light";
}
